export const COMPLETION_PERCENTAGE_VALUE = 100;
export const APPLICATION_NOT_STARTED_VALUE = 0;
